module.exports = __webpack_public_path__ + "static/media/bg1.919d0713.jpg";